import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { headerHeightLg } from '@/constants/layouts';
import { ROUTE_ACCOUNT, ROUTE_DASHBOARD } from '@/constants/routes';
import { Button, Flex, Image, Link, Popover, Text } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';
import { DashboardNavigationBarProps } from '../types';
import NavigationBarSelectedItem from './navigation-bar-selected-item';

export default function DashboardNavigationBarDesktop({
  handleLogout,
  menuItems,
  activeItem,
  containerProps,
  navBarRef,
}: DashboardNavigationBarProps) {
  return (
    <Flex
      as="nav"
      justifyContent="center"
      alignItems="center"
      height={headerHeightLg}
      px={{ lg: 'spacer-16', xl: 'spacer-24', xxl: 'spacer-32' }}
      py="spacer-6"
      background="gradient-01"
      w="100%"
      zIndex={2}
      {...containerProps}
      ref={navBarRef}
    >
      <Flex width="100%" maxW="1184px" justifyContent="space-between" alignItems="center" gap="10px">
        <Link
          width="auto"
          as={ReactRouterLink}
          to={ROUTE_DASHBOARD}
          aria-label="Navigate home"
          alignItems="center"
          justifyContent="flex-start"
          gap={0}
        >
          <Image src="/images/logo-catch.svg" width="140px" height="25px" alt="Catch logo" />
          <Text as="span" display="inline-block" mt="-25px" color="white" fontSize="12px" fontWeight="400">
            beta
          </Text>
        </Link>
        <Flex as="ul" listStyleType="none" alignItems="center" justifyContent="center">
          {menuItems.map((menuItem) =>
            menuItem.item === activeItem ? (
              <NavigationBarSelectedItem key={menuItem.item} label={menuItem.label} />
            ) : (
              <Link key={menuItem.item} to={menuItem.href} as={ReactRouterLink} variant="link-light" px={4} py={7}>
                {menuItem.label}
              </Link>
            )
          )}
        </Flex>
        <Popover placement="bottom-end">
          <Popover.Trigger>
            <Button aria-label="open account options" variant="link-ghost" p={0} borderRadius="50%" overflow="hidden">
              <IconCatch
                icon="Profile-User"
                height="40px"
                width="40px"
                backgroundColor="lightBlue"
                p={2}
                alt="User icon"
              />
            </Button>
          </Popover.Trigger>
          <Popover.Content w="205px">
            <Popover.Body display="flex" flexDirection="column" alignContent="start">
              <Link variant="ghost" as={ReactRouterLink} to={`${ROUTE_ACCOUNT}?tab=account`} w="100%">
                Account
              </Link>
              <Link variant="ghost" as={ReactRouterLink} to={`${ROUTE_ACCOUNT}?tab=risk`} w="100%">
                Risk Assessment
              </Link>
            </Popover.Body>
            <Popover.Footer>
              <Link role="button" onClick={handleLogout} variant="ghost" w="100%">
                Log out
              </Link>
            </Popover.Footer>
          </Popover.Content>
        </Popover>
      </Flex>
    </Flex>
  );
}
